import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const BoxPromise = ({ className }: Props) => {
    const { t } = useGranite();

    const { sku, boxLogisticInformation, preferredStore, isBoxArticle } =
        useDeliveryItemContext();

    const logisticInformation =
        boxLogisticInformation || t(`ecommerce.label.pickup.box.${sku}`);
    const shopName = preferredStore?.shopName;

    if (!isBoxArticle) return null;

    return (
        <div className={cn(className)}>
            {shopName && (
                <div className={cn("tw:text-sm tw:font-bold")}>
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            {!shopName && (
                <div className={cn("tw:text-sm tw:font-light")}>
                    {t("general.ecommerce.clickAndCollect.noStore")}
                </div>
            )}
            <div className={cn("tw:text-sm")}>
                <span>
                    <i className={cn("las la-check tw:mr-1")}></i>
                    {logisticInformation}
                </span>
            </div>
        </div>
    );
};
